module.exports = __webpack_public_path__ + "img/yahoo.b86e8c09.jpg";